import { useDispatch, useSelector } from 'react-redux';
import { open, close } from '../redux/slices/modalSlice';

export default function useModal() {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.modal);

  return {
    open: ({ content, options, callback }) =>
      dispatch(open({ content, options, callback })),
    close: () => dispatch(close()),
    data: state
  };
}
